module.exports = __webpack_public_path__ + "static/media/print-instrucoes-conta-2.1981c433.png";